/*

THIS IS JUST AN EXAMPLE SET UP FOR A REDUCER.
WE CAN DO WHATEVER WE WANT IN IT I JUST WANTED TO GIVE A BASE SKELETON - SAMEER

*/

import * as types from '../actions/actionTypes';

const initialState = {
  color: "#fff",
  color_light: "#22cc56",
  extra_charge: "0",
  hide_prices: "false",
  link_store_home: "https://zenhq-tenant-one.myshopify.com/",
  logo: "",
  header_background: "https://s3.ca-central-1.amazonaws.com/staging.checkout.zenhq.io/images/checkout_header_image.png",
  max_days_in_future: "15",
  max_visible_dates: "10",
  name: "Zenhq Tenant 0",
  weekly_delivery: "true",
  privacy_policy: "Privacy policy body",
  refund_policy: "Refund policy body",
  terms_of_services: "Terms of services body",
  time_zone: "America/New_York",
  calendar_week_end_day: "0"
}

export const frontConfigReducer = (state = initialState, action) => {
  let newState = action.payload
  switch (action.type) {
    case types.SET_FRONT_CONFIG:
      return {...state, ...newState};
    default:
      return state;
  }
}
